import { FETCH_LEAD, FETCH_LEADS, FETCH_MORE_LEADS } from './PanelActions'

const INITIAL_STATE = {
  leads: [],
  meta: {},
  loadingMore: false,
  triggers: [],
  editingLead: {},
  filters: {},
  attendants: [],
}

// Chave dos filtros sem a página: identifica a "lista" que está na tela.
const listKey = (filters = {}) => {
  const { page, ...rest } = filters
  return JSON.stringify(rest)
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_LEADS.SUCCESS:
      return {
        ...state,
        leads: action.payload.data.data,
        meta: action.payload.data.meta || {},
        triggers: action.payload.data.triggers,
        filters: action.payload.filters,
        loadingMore: false,
      }
    case FETCH_MORE_LEADS.ACTION:
      return { ...state, loadingMore: true }
    case FETCH_MORE_LEADS.SUCCESS: {
      const { data, filters } = action.payload
      const nextPage = Number(state.meta?.current_page) + 1

      // Descarta respostas atrasadas: filtro/aba mudou ou a página já entrou.
      if (
        listKey(filters) !== listKey(state.filters) ||
        Number(data.meta?.current_page) !== nextPage
      ) {
        return { ...state, loadingMore: false }
      }

      return {
        ...state,
        leads: [...state.leads, ...data.data],
        meta: data.meta,
        loadingMore: false,
      }
    }
    case FETCH_MORE_LEADS.FAILURE:
      return { ...state, loadingMore: false }
    case FETCH_LEAD.SUCCESS:
      return {
        ...state,
        editingLead: action.payload.data?.data,
        attendants: action.payload.data?.attendants,
      }
    default:
      return state
  }
}
